export default __webpack_public_path__ + "static/1-b8fc62a480b4af939c602922d60a0ed5.gif";